import { ChipTab, Stack } from '@all-manager/design-system-v2';
import { TimelineEntityTypeFilter, useActivityTimelineFilter } from "./useActivityTimelineFilter";

type Props = {
  currentFilter: TimelineEntityTypeFilter;
  onFilterChange: (filter: TimelineEntityTypeFilter) => void;
  counts?: Record<TimelineEntityTypeFilter, number>;
};

const FILTERS: { key: TimelineEntityTypeFilter; label: string }[] = [
  { key: 'all', label: 'Tout' },
  { key: 'communication', label: 'Échanges' },
  { key: 'quote', label: 'Devis' },
  { key: 'event', label: 'Rendez-vous' },
  { key: 'incident', label: 'Incidents' },
  { key: 'document', label: 'Documents' },
  { key: 'other', label: 'Autres' },
];

export default function ActivityTimelineFilter(props: Props) {
  const { handleSelect } = useActivityTimelineFilter(props);

  return (
    <Stack direction="row" spacing={1} wrap="wrap" role="tablist" aria-label="Filtrer l'historique">
      {FILTERS.map((filter) => (
        <ChipTab
          key={filter.key}
          label={filter.label}
          count={props.counts ? props.counts[filter.key] : undefined}
          selected={props.currentFilter === filter.key}
          onClick={() => handleSelect(filter.key)}
        />
      ))}
    </Stack>
  );
}
